import { useEffect, useState } from 'react'

const WORDS = [
  'Gala',
  'Benefit',
  'Happy Hour',
  'Luncheon',
  'Breakfast',
  'Golf Outing',
  'Race/Walk',
  'Pickleball',
  'School',
  'Association',
]

function usePrefersReducedMotion() {
  const [reduced, setReduced] = useState(false)

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return
    const mql = window.matchMedia('(prefers-reduced-motion: reduce)')
    setReduced(mql.matches)
    const onChange = (e: MediaQueryListEvent) => setReduced(e.matches)
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [])

  return reduced
}

export default function RotatingWord() {
  const reducedMotion = usePrefersReducedMotion()
  const [index, setIndex] = useState(0)

  useEffect(() => {
    if (reducedMotion) return
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % WORDS.length)
    }, 1000)
    return () => clearInterval(id)
  }, [reducedMotion])

  // When reduced motion is on, never cycle and never animate — show a static word.
  const word = reducedMotion ? WORDS[0] : WORDS[index]

  // Every word shares one grid cell (col/row 1): the box stays a single line tall but
  // is always as wide as the longest word, so "Fundraiser Free" never shifts.
  return (
    <span className="inline-grid">
      {WORDS.map((w) => (
        <span key={w} className="invisible col-start-1 row-start-1" aria-hidden="true">
          {w}
        </span>
      ))}
      <span
        key={reducedMotion ? 'static' : index}
        className={
          'col-start-1 row-start-1 text-primary' +
          (reducedMotion
            ? ''
            : ' motion-safe:animate-in motion-safe:fade-in motion-safe:slide-in-from-bottom-2 motion-safe:duration-500 motion-safe:ease-out')
        }
      >
        {word}
      </span>
    </span>
  )
}
